import Phaser from 'phaser';
import { DEPTH, PLAYER_SIZE, PLAYER_SPEED } from '../core/Config';
import { GameSettings } from '../core/GameSettings';
import { anyDown } from '../core/Keybinds';
import type { GameKeys } from '../core/Keybinds';

export class Player extends Phaser.Physics.Arcade.Sprite {
  private readonly keys: GameKeys;

  constructor(scene: Phaser.Scene, x: number, y: number, keys: GameKeys) {
    super(scene, x, y, 'player_sheet', 0);
    this.keys = keys;

    scene.add.existing(this);
    scene.physics.add.existing(this);

    this.setSize(PLAYER_SIZE.width, PLAYER_SIZE.height);
    this.setOffset(9, 16);
    this.setCollideWorldBounds(true);
    this.setDepth(DEPTH.ACTOR + y);
    this.setScale(1);
  }

  update(lockMovement = false) {
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setVelocity(0, 0);

    if (lockMovement) {
      this.playAnimation(0, 0);
      this.setDepth(DEPTH.ACTOR + this.y);
      return;
    }

    let vx = 0;
    let vy = 0;

    if (anyDown(this.keys.left, ['left'])) vx -= 1;
    if (anyDown(this.keys.right, ['right'])) vx += 1;
    if (anyDown(this.keys.up, ['up'])) vy -= 1;
    if (anyDown(this.keys.down, ['down'])) vy += 1;

    const vector = new Phaser.Math.Vector2(vx, vy).normalize().scale(PLAYER_SPEED * GameSettings.getSpeedMultiplier());
    body.setVelocity(vector.x, vector.y);

    this.playAnimation(vector.x, vector.y);
    this.setDepth(DEPTH.ACTOR + this.y);
  }

  private playAnimation(vx: number, vy: number) {
    const moving = Math.abs(vx) > 0 || Math.abs(vy) > 0;
    if (!moving) {
      const last = this.getData('lastDirection') ?? 'down';
      this.anims.play(`player-${last}-idle`, true);
      return;
    }

    let direction: 'left' | 'right' | 'up' | 'down' = 'down';
    if (Math.abs(vx) > Math.abs(vy)) {
      direction = vx < 0 ? 'left' : 'right';
    } else {
      direction = vy < 0 ? 'up' : 'down';
    }

    this.setData('lastDirection', direction);
    this.anims.play(`player-${direction}-walk`, true);
  }
}
